import API from './index';

export const contactsAPI = {
  getAll: (params) => API.get('/contacts', { params }),
  getStats: () => API.get('/contacts/stats'),
  create: (contact) => API.post('/contacts', contact),
  updateStatus: (id, status) => API.put(`/contacts/${id}/status`, { status })
};